(function () {
    'use strict';

    function main() {
        var controller = {
            init: function () {
                wo$('[data-toggle="btns"] .btn').on('click', function () {
                    var $this = wo$(this);
                    $this.parent().find('.active').removeClass('active');
                    $this.addClass('active');
                });

                wo$('.popup-gallery').each(function () {
                    wo$(this).magnificPopup({
                        delegate: 'a.gallery-item',
                        type: 'image',
                        gallery: {
                            enabled: true
                        }
                    });
                });
            }
        };

        controller.init();
    }

    WhistleOut.initModule(import.meta.url, main);
})();
